import { useUserPreferences } from '@/providers/UserPreferencesProvider';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';

interface ManageTemplatesSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ManageTemplatesSheet({ open, onOpenChange }: ManageTemplatesSheetProps) {
  const { preferences } = useUserPreferences();

  // Determine which side to open from based on sidebar position
  // If sidebar is on the right, open sheet from left, otherwise from right
  const sheetSide = preferences.sidebarPosition === 'right' ? 'left' : 'right';

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side={sheetSide} className="w-full sm:max-w-xl">
        <SheetHeader>
          <SheetTitle>Manage Templates</SheetTitle>
          <SheetDescription>
            Create, edit, and organize your project templates.
          </SheetDescription>
        </SheetHeader>

        <div className="mt-6 space-y-4">
          {/* Placeholder content */}
          <div className="flex items-center justify-center h-64 border-2 border-dashed rounded-lg">
            <div className="text-center space-y-2">
              <p className="text-sm text-muted-foreground">
                Template management functionality
              </p>
              <p className="text-xs text-muted-foreground">
                Coming soon...
              </p>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
